import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Icon,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import ModalActions from 'components/ModalActions';
import { functions } from 'helpers/functions';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { listDeliveryProvider } from 'store/Orbita/DeliveryProviders/actions';
import { isUrl } from 'validations/rules';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  others: any[];
  isModal: boolean;
  open?: boolean;
  onClose?: any;
  onOk: any;
  other?: any;
  offer?: any;
  newProduct?: boolean;
  alphaclass?: boolean;
  hasHotmart?: boolean;
}

interface IStates {
  selected: any;
  parameters: any[];
  fields: any;
  defaultFields: any;
  pinParameters: any;
  open: boolean;
  inputSelected: any;
}

const HOTMART = 4;

class Other extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.props.dispatch(listDeliveryProvider(this.props.newProduct));
    this.state = {
      selected: '',
      inputSelected: '',
      parameters: null,
      open: this.props.open,
      pinParameters: null,
      fields: {},
      defaultFields: {},
    };
  }

  handleChange = (event: any) => {
    const { others } = this.props;
    const id = event.target.value;
    let newSelected = others && others.length && others.filter((item: any) => item.id === id)[0];
    newSelected.method_id = `${newSelected.id}`;
    newSelected.method_name = newSelected.name;
    this.setState({
      selected: newSelected,
      parameters: others.filter((item: any) => item.id === newSelected.id)[0].parameters,
      inputSelected: id,
      fields: newSelected,
    });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.parameters) this.state.parameters.map((p) => this.onChangeProp(p.name, this.state.defaultFields[p.name]));
    this.props.onClose();
    this.setState({ open: false });
  };

  handleOk = () => {
    const onOk = this.props.onOk;
    let { selected, parameters } = this.state;
    let msg = '';
    let isValid = true;

    if (selected && selected.id === 9) {
      const { pinParameters } = this.state;
      selected = Object.assign(selected, pinParameters);

      if (selected) {
        isValid = false;
        this.props.onClose();
      }
    } else {
      for (let prop in parameters) {
        let propName = parameters[prop].name;
        let label = parameters[prop].label;

        if (selected[propName] && selected[propName] !== '' && isValid) {
          if (propName.includes('url')) {
            if (isUrl(selected[propName])) {
              isValid = false;
              msg = `Por favor informe uma Url válida no campo ${label}`;
            } else {
              isValid = true;
            }
          } else {
            isValid = true;
          }
        } else {
          isValid = false;
          if (!msg) {
            msg = `Por favor preencha o campo ${label}`;
          }
          break;
        }
      }
    }

    if (selected && selected.id) {
      if (isValid) {
        if (onOk) {
          if (functions.isEqual(selected, this.state.defaultFields)) {
            return this.props.onClose();
          }

          selected.new = true;
          selected.can_modify = true;
          onOk(selected, this.props.other);

          if (!this.props.other) {
            toast.success(`Item ${selected.name} adicionado com sucesso!`);
          }
          this.setState({ selected: '', parameters: null, pinParameters: null, inputSelected: '' });
        }
      } else {
        toast.warn(`${msg}`);
        msg = '';
      }
    } else {
      toast.warn('Por favor selecione uma forma de entrega do tipo outros');
    }
  };

  onChangePin = (field: any, value: any) => {
    let pinParameters = this.state.pinParameters || {};
    pinParameters[field] = value;
    this.setState({ pinParameters });
  };

  onChangeProp = (propName: any, value: any) => {
    let fields = this.state.fields;
    fields[propName] = value;
    this.setState({ fields });
  };

  componentDidMount() {
    const nextProps = this.props;
    if (nextProps.other) {
      let parameters =
        nextProps.others && nextProps.others.length && nextProps.others.filter((item: any) => item.id === parseInt(nextProps.other.method_id))[0];
      parameters = parameters && parameters.parameters;
      this.setState({
        selected: nextProps.other,
        inputSelected: parseInt(nextProps.other.method_id),
        parameters,
        fields: nextProps.other,
      });

      this.setState({ defaultFields: { ...nextProps.other } });
    }
  }

  render() {
    const { others, isModal, open, hasHotmart } = this.props;
    const { parameters, fields, inputSelected } = this.state;
    const filteredOthers = Array.isArray(others)
      ? others.filter((o) => {
          if (o.id === HOTMART && !hasHotmart) return false;
          if (o.id === 47) return false;
          return true;
        })
      : [];

    const content = (
      <form>
        <FormControl style={{ width: '100%' }}>
          <InputLabel shrink htmlFor='nutror'>
            Selecione um outro tipo de entrega
          </InputLabel>
          <Select input={<Input />} disableUnderline inputProps={{ disableUnderline: true }} value={inputSelected} onChange={this.handleChange}>
            {filteredOthers.map((item: any) => (
              <MenuItem key={`other-${item.id}`} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
          {parameters && parameters.length
            ? parameters.map((param: any) => (
                <React.Fragment key={param.name}>
                  <TextField
                    key={`parameter-${param.name}`}
                    id={param.name}
                    label={param.label}
                    onChange={(e: any) => this.onChangeProp(param.name, e.target.value)}
                    value={fields[param.name]}
                    margin='normal'
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {param && param.hint && <FormHelperText>{param.hint}</FormHelperText>}
                </React.Fragment>
              ))
            : null}
        </FormControl>
      </form>
    );
    return (
      <div>
        {isModal ? (
          <ModalActions buttonOk='Salvar' title={'Entrega de Conteúdo'} open={open} onClose={this.handleClose} onOk={this.handleOk}>
            {content}
          </ModalActions>
        ) : (
          <Card>
            <CardHeader
              title='Entrega de Conteúdo'
              action={
                <IconButton>
                  <Icon>clear</Icon>
                </IconButton>
              }
            />
            <CardContent>{content}</CardContent>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    others: state.orbita.DeliveryProvider.list,
  };
}

export default connect(mapStateToProps)(Other);
